<template>
  <ApolloCarousel :content="value" />
</template>

<script>
export default {
  name: "ControlApolloGridCarouselEditor",
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
};
</script>
